<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deleteTicket()">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div>
            <v-data-table
                :headers="headers"
                :items="paginateAllMyTickets"
                no-results-text="Herhangi bir sonuç bulunamadı..."
                disable-pagination
                :hide-default-footer="true"
                :server-items-length="meta_ticket.total"
                @update:options="sort"
            >
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Biletlerim</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-col sm="1">
                            <b-form-select 
                                v-model="pageSize" 
                                :options="pageSizes" 
                                @change="handlePageSizeChange"
                            ></b-form-select>
                        </v-col>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        {{ meta_ticket.total }} kayıt
                        <v-divider class="mx-4" inset vertical></v-divider>
                        {{ meta_ticket.from }} - {{ meta_ticket.to }}
                        <v-divider class="mx-4" inset vertical></v-divider>
                        
                        <b-button
                            v-if="hasPermission('tickets.create')"
                            size="sm"
                            variant="primary"
                            @click="addTicket()"
                        >
                            YENİ BİLET TALEBİ OLUŞTUR
                        <i class="la la-plus"></i>
                        </b-button>

                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Araştır"
                            single-line
                            hide-details
                            @input="searchTable"
                        ></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="m-demo__preview m-demo__preview--btn">
                        <v-icon
                            class="la la-eye"
                            data-toggle="m-popover" title="Görüntüle"
                            @click="viewTicket(item.id)"
                        >
                        </v-icon>
        
                        <v-icon v-if="hasPermission('tickets.update') && isPastDate(item.match.match_date)"
                            class="la la-edit"
                            data-toggle="m-popover" title="Güncelle"
                            @click="editTicket(item.id)"
                        >
                        </v-icon>

                        <v-icon v-if="hasPermission('tickets.delete') && isPastDate(item.match.match_date)"
                            class="la la-trash"
                            data-toggle="m-popover" title="Sil"
                            @click="showDeleteDialog(item.id)"
                        >
                        </v-icon>

                        
                    </div>    
                </template>
                <template v-slot:[`item.status`]="{item}">
                    <b-badge class="mr-1" :variant="getClass(item.status)">{{ item.status }}</b-badge>
                </template>

                <template v-slot:[`item.created_at`]="{ item }">
                    <span>{{ item.created_at | formatDateTime }}</span>
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                    <span>{{ item.updated_at | formatDateTime }}</span>
                </template>

                <template v-slot:[`item.reservation_expires_at`]="{ item }">
                    <span>{{ item.reservation_expires_at | formatDateTime }}</span>
                </template>

                

                <template v-slot:footer>
                    <v-toolbar flat>
                        <template>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <b-pagination
                                        v-model="page"
                                        :total-rows="meta_ticket.total"
                                        :per-page="itemsPerPage"
                                        size="lg"
                                        @input="handlePageChange"
                                        align="right"
                                        first-number
                                        last-number
                                    ></b-pagination>
                                </v-col>
                            </v-row>
                        </template>
                    </v-toolbar>
                </template>
            
            </v-data-table>
        </div>
        
        <br />
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
          
    </div>
    
</template>

<script>

import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import { PAGINATE_ALL_MY_TICKETS } from "@/core/services/store/tickets.module";
import { DELETE_TICKET } from "@/core/services/store/tickets.module";

export default {
    name: "tickets-list",
    data() {
        return {
            title: "",
            search: "",
            dialog: false,
            itemToDelete: "",
            page: 1,
            itemsPerPage: 10,
            pageSize: 10,
            pageSizes: [10, 25, 50, 100],
            totalPages: 0,
            currentPage: 1,
            total: 0,
            from: 0, 
            to: 0,
            sortBy: 'updated_at',
            sortDesc: true,
            timer: null,
            row: false,
            headers: [
            { text: "İşlemler", value: "actions", sortable: false },
                { text: "ID", align: "start", value: "id" },
                { text: "Üye İsim", align: "start", value: "passolig.name" },
                { text: "Üye İsim", align: "start", value: "passolig.surname" },
                { text: "Passolig Açılış Belge Türü", align: "start", value: "passolig.document_type" },
                { text: "Passolig Açılış Belge  No", align: "start", value: "passolig.document_no" },
                { text: "Maç", align: "start", value: "match.name" },
                { text: "Tribün", align: "start", value: "seat.row.block.stand.name" },
                { text: "Blok", align: "start", value: "seat.row.block.name" },
                { text: "Sıra", align: "start", value: "seat.row.name" },
                { text: "Koltuk", align: "start", value: "seat.name" },
                { text: "Yakınlık", align: "start", value: "passolig.kinship" },
                { text: "Açıklama", align: "start", value: "description" },
                { text: "Statü", align: "start", value: "status" },
                { text: "Ekleyen", value: "user_created_name[0].name" },
                { text: "Ekleme Tarihi", value: "created_at" },
                { text: "Rezervasyonu Yapan", value: "reserved_by_user.name" },
                { text: "Rezervasyon Geçerlilik", value: "reservation_expires_at" }
            ],
        };
    },

    methods: {
        handlePageChange(value) {
            this.currentPage = value;
            this.paginate();
        },

        searchTable(value){
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = value;
                this.paginate();
            }, 500);
        },

        sort(options){
            this.sortBy = options.sortBy;
            this.sortDesc = options.sortDesc;
            this.paginate();
        },

        handlePageSizeChange(size) {
            this.pageSize = size;
            this.itemsPerPage = size;
            this.page = 1;
            this.paginate();
        },
        
        showDeleteDialog(id) {
            this.itemToDelete = id
            this.dialog = !this.dialog
        },

        addTicket() {
            this.$router.push({
                name: "my-tickets-form",
                params: { formType: "add"}
            });
        },

        editTicket(id) {
            this.$router.push({
                name: "my-tickets-form",
                params: { id: id, formType: "edit" }
            });
        },

        viewTicket(id) {
            this.$router.push({
                name: "my-tickets-form",
                params: { id: id, formType: "view" }
            });
        },
        
        deleteTicket() {
            this.dialog = false;
            
            var itemToDelete = this.itemToDelete;
            this.$store.dispatch(DELETE_TICKET, {
                    itemToDelete
                });
            this.paginate();
        },
        paginate() {
            var pageNumber = this.page;
            var itemsPerPage = this.itemsPerPage;
            var sortBy = this.sortBy;  
            var sortDesc = this.sortDesc; 
            var search = this.search;
            var x = 1;

            this.$store.dispatch(PAGINATE_ALL_MY_TICKETS, {
                    itemsPerPage, 
                    pageNumber, 
                    sortBy, 
                    sortDesc, 
                    search,
                    x
                });
            },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },
        
        getClass(status) {
            if (status == "Onay Gerekiyor, Pasif") return 'danger';
            if (status == "Onaylandı") return 'primary';
        },

        getText(id) {
            if (id == 1) return 'Aktif'
            else return 'Pasif'
        },

        isPastDate(date) {
            return new Date(date) > new Date();
        }
        
        },
    created(){
        this.$store.dispatch('getUserMenu');
        
    },
   
    computed: {
        
        ...mapGetters(["paginateAllMyTickets", "meta_ticket", "currentUserMenu"]),
        
        ...mapState({
            loading: state => state.tickets.loading,
        }),
        
    },

};
</script>
